<div class="min-h-screen w-full flex flex-col items-center justify-center relative bg-slate-900 text-white">
    <div class="absolute inset-0 z-0 opacity-20">
        <div class="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,#6366F1_1px,transparent_0)] [background-size:40px_40px]"></div>
    </div>
    <main class="z-10 w-full max-w-md px-6 py-10">
        <!-- Loading State -->
        <div *ngIf="isLoading()" class="flex flex-col items-center space-y-6" aria-busy="true">
            <div class="relative">
                <div class="w-20 h-20 rounded-full border-4 border-indigo-500/30"></div>
                <div class="absolute top-0 w-20 h-20 rounded-full border-4 border-t-indigo-500 animate-spin"></div>
            </div>
            <div class="text-center space-y-3">
                <h2 class="text-2xl font-bold text-white">Authenticating...</h2>
                <p class="text-slate-400 text-sm">Verifying your portal session. Please wait a moment.</p>
            </div>
        </div>

        <!-- Error State -->
        <div *ngIf="!isLoading() && errorMessage()" class="flex flex-col items-center space-y-6 text-center">
            <div class="w-16 h-16 rounded-full bg-red-500/20 text-red-400 flex items-center justify-center text-3xl">
                ⚠️
            </div>
            <div class="space-y-3">
                <h2 class="text-xl font-bold text-white">Authentication Error</h2>
                <p class="text-slate-300 text-sm bg-slate-800/80 p-4 rounded-xl border border-slate-700/50">
                    {{ errorMessage() }}
                </p>
            </div>
            <button (click)="redirectToPortal()"
                class="px-6 py-2.5 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-semibold transition shadow-lg shadow-indigo-600/30">
                Return to Auth Portal
            </button>
        </div>
    </main>
</div>
